import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import styles from './style';
import { FORMS } from '../../../constants';
import LoginTextField from '../../../fields/normal/LoginTextField';
import { email, required } from '../../../utilities/validators';

const TextFieldComponent = ({
  label,
  labelTouched,
  labelUntouched,
  FormHelperText,
  input,
  meta: { touched, invalid, error, dirty, active },
  ...custom
}) => (
  <LoginTextField
    label={
      label || (labelTouched && dirty) || active || touched
        ? labelTouched
        : labelUntouched || 'generic label'
    }
    placeholder={label}
    error={touched && invalid}
    helperText={touched && error}
    {...input}
    {...custom}
  />
);

TextFieldComponent.propTypes = {
  label: PropTypes.string.isRequired,
  labelTouched: PropTypes.string.isRequired,
  labelUntouched: PropTypes.string.isRequired,
  FormHelperText: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  meta: PropTypes.shape({
    invalid: PropTypes.bool,
    touched: PropTypes.bool,
    dirty: PropTypes.bool,
    active: PropTypes.bool,
    error: PropTypes.string,
  }).isRequired,
};

const ResendVerificationEmailForm = props => {
  const {
    handleSubmit,
    pristine,
    submitting,
    classes,
    invalid,
    isLoginLoading,
    submitFailed,
    error,
  } = props;

  return (
    <form onSubmit={handleSubmit}>
      <div className={classes.fieldContain}>
        <Field
          name="email"
          component={TextFieldComponent}
          labelUntouched={
            <Typography
              variant="h6"
              color="textSecondary"
              className={classes.placeText}
            >
              enter email address
            </Typography>
          }
          labelTouched={
            <Typography
              variant="h6"
              color="textSecondary"
              className={classes.placeText}
            >
              email address
            </Typography>
          }
          validate={[email, required]}
        />
      </div>
      {submitFailed && error && (
        <Typography
          className={classes.formErrorMsg}
          variant="body2"
          color="error"
        >
          {error}
        </Typography>
      )}
      <div className={classes.buttonContain}>
        <div className={classes.buttonContain_submit}>
          <Button
            className={classes.mainButton}
            type="submit"
            disabled={pristine || submitting || invalid || isLoginLoading}
            variant="contained"
            color="primary"
          >
            Resend Verification Email
            {isLoginLoading && (
              <CircularProgress size={34} className={classes.buttonProgress} />
            )}
          </Button>
        </div>
      </div>
    </form>
  );
};

ResendVerificationEmailForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  isLoginLoading: PropTypes.bool.isRequired,
  submitFailed: PropTypes.bool.isRequired,
  error: PropTypes.string,
  classes: PropTypes.shape({
    fieldContain: PropTypes.string,
    formErrorMsg: PropTypes.string,
    buttonContain: PropTypes.string,
    buttonContain_submit: PropTypes.string,
    buttonProgress: PropTypes.string,
  }).isRequired,
};
ResendVerificationEmailForm.defaultProps = {
  error: '',
};

export default withStyles(styles)(
  reduxForm({
    form: FORMS.RESEND_VERIFICATION_EMAIL_FORM, // a unique identifier for this form
  })(ResendVerificationEmailForm),
);
